/**
 * @file Re-exports the TiersListInput component.
 */
import TiersListInput from "./TiersListInput";

export default TiersListInput;
